<jhi-bary-card [titleKey]="titleKey">
  <div class="d-flex flex-column flex-sm-row justify-content-start align-items-center sizeDiv" body>
    <div class="col-lg-2">
      <ul class="list-unstyled ml-2">
        <li *ngFor="let statsButton of buttons" class="mb-2">
          <button
            class="round"
            type="button"
            mdbBtn
            mdbWavesEffect
            color="main"
            (click)="changeCurrentData(statsButton)"
            [block]="true"
            [class.invert]="currentData.key !== statsButton.key"
          >
            <div class="row">
              <div>
                <div class="float-left stats-total font-weight-bold">
                  {{ statsButton.value |number:'1.' + statsButton.precision + '-' + statsButton.precision }}
                  <span *ngIf="statsButton.unit"> {{ statsButton.unit }}</span>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <span> {{ statsButton.titleKey | translate }} </span>
            </div>
          </button>
        </li>
      </ul>
      <hr />
      <div class="row ml-2">
        <mdb-select [options]="optionsSelect" [(ngModel)]="period" (ngModelChange)="changePeriod()" placeholder="Choose your temporality"></mdb-select>
      </div>
      <hr *ngIf="personalize" />
      <div class="row ml-2" *ngIf="personalize">
        <mdb-date-picker
          [inline]="true"
          name="mydate"
          [options]="myDatePickerOptions"
          [placeholder]="'Date de début'"
          required
          (dateChanged)="onDateChange($event, 'start')"
        ></mdb-date-picker>
      </div>
      <div class="row ml-2" *ngIf="personalize">
        <mdb-date-picker
          [inline]="true"
          name="mydate"
          [options]="myDatePickerOptions"
          [placeholder]="'Date de fin'"
          required
          (dateChanged)="onDateChange($event, 'end')"
        ></mdb-date-picker>
      </div>
      <div *ngIf="controllerDatePicker!== ''">{{ controllerDatePicker }}</div>
    </div>
    <div class="col-lg-9 mx-auto">
      <div *ngIf="loading">
        <span class="spinner-border spinner-border-sm"></span>
      </div>
      <div *ngIf="!loading && dataService.chartType && dataService.chartColors && dataService.chartDatasets">
        <canvas
          mdbChart
          class="my-auto"
          [chartType]="dataService.chartType"
          [datasets]="dataService.chartDatasets"
          [labels]="dataService.chartLabels"
          [colors]="dataService.chartColors"
          [options]="dataService.chartOptions"
          [legend]="dataService.chartLegend"
        >
        </canvas>
      </div>
    </div>
  </div>
</jhi-bary-card>
